<template>
  <div>
    <div class="c-office-filter__sticky-wrapper">
      <div class="c-office-filter o-width-limiter--full">
        <div class="c-office-filter__wrapper">
          <div class="c-office-filter__content-wrapper">
            <h1>{{ this.translate.findpremise }}</h1>
            <div class="c-office-filter__dropdown-wrapper">
              <v-office-filter-dropdown
                @populate-filter="handleFilterData"
                tag="plats"
                :button-text="placesButtonText"
                :select-area="this.translate.selectarea"
                :select="this.translate.select"
                :selecttag="this.translate.selectarealabel"
                :dropdown-open="this.activeFilter === 'plats'"
              >
                <ul
                  class="c-office-filter-dropdown__list"
                  v-if="this.activeFilter === 'plats'"
                  v-click-outside="handleClickOutside"
                >
                  <div
                    v-if="activeFilter === 'plats'"
                    class="c-office-filter__city-wrapper"
                    v-for="city in cities"
                  >
                    <li class="c-office-filter__city" v-if="!singleCity">
                      <label @click="addRegions(city)">
                        <input
                          type="checkbox"
                          :value="city.value"
                          v-model="selectedPlaces"
                        />
                        {{ city.display }}
                      </label>
                    </li>
                    <li
                      class="c-office-filter__region"
                      v-for="region in regions"
                      v-if="region.group === city.display"
                    >
                      <div>
                        <label>
                          <input
                            type="checkbox"
                            :value="region.value"
                            v-model="selectedPlaces"
                          />
                          <span>{{ region.display }}</span>
                        </label>
                      </div>
                    </li>
                  </div>
                </ul>
              </v-office-filter-dropdown>
              <v-office-filter-dropdown
                @populate-filter="handleFilterData"
                tag="lokal"
                :button-text="typeOfBuildingButtonText"
                :select-area="this.translate.selectarea"
                :select="this.translate.select"
                :selecttag="this.translate.selectpremiselabel"
                :dropdown-open="this.activeFilter === 'lokal'"
              >
                <ul
                  class="c-office-filter-dropdown__list"
                  v-if="this.activeFilter === 'lokal'"
                  v-click-outside="handleClickOutside"
                >
                  <div
                    v-if="activeFilter === 'lokal'"
                    class="c-office-filter__place-wrapper"
                    v-for="premise in premiseType"
                  >
                    <li class="c-office-filter__place">
                      <label>
                        <input
                          type="checkbox"
                          :value="premise.value"
                          v-model="selectedTypesOfBuildings"
                        />
                        {{ premise.display }}
                      </label>
                    </li>
                  </div>
                </ul>
              </v-office-filter-dropdown>
              <v-office-filter-dropdown
                @populate-filter="handleFilterData"
                tag="yta"
                :button-text="buildingSizeText"
                :select-area="this.translate.selectarea"
                :select="this.translate.select"
                :selecttag="this.translate.selectspacelabel"
                :dropdown-open="this.activeFilter === 'yta'"
              >
                <ul
                  class="c-office-filter-dropdown__list"
                  v-if="this.activeFilter === 'yta'"
                  v-click-outside="handleClickOutside"
                >
                  <div v-if="activeFilter === 'yta'">
                    <div class="c-office-filter__size-input-block">
                      <div class="c-office-filter__size-input-heading">
                        {{ this.translate.showdesiredspace }}
                      </div>
                      <div class="c-office-filter__size-input-wrapper">
                        <div class="c-office-filter__size-input-container">
                          <div class="c-office-filter__size-input-tag">Min</div>
                          <input
                            type="number"
                            class="c-office-filter__size-input"
                            min="0"
                            placeholder="0"
                            v-model="minSize"
                          />
                          <span class="c-office-filter__size-input-m2-tag"
                            >m<sup>2</sup></span
                          >
                        </div>
                        <div
                          aria-hidden="true"
                          class="c-icon c-icon--xs c-office-filter-dropdown__toggle-icon"
                        >
                          <svg>
                            <use :xlink:href="`#icon-minus`"></use>
                          </svg>
                        </div>
                        <div class="c-office-filter__size-input-container">
                          <div class="c-office-filter__size-input-tag">Max</div>
                          <input
                            type="number"
                            class="c-office-filter__size-input"
                            min="0"
                            placeholder="0"
                            v-model="maxSize"
                          />
                          <span class="c-office-filter__size-input-m2-tag"
                            >m<sup>2</sup></span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </ul>
              </v-office-filter-dropdown>

              <v-office-filter-dropdown
                @populate-filter="handleFilterData"
                tag="arbetsplatser"
                :button-text="buildingNumberOfWorkplaces"
                :select-area="this.translate.selectarea"
                :select="this.translate.select"
                :selecttag="this.translate.selectworkplaceslabel"
                :dropdown-open="this.activeFilter === 'arbetsplatser'"
              >
                <ul
                  class="c-office-filter-dropdown__list"
                  v-if="this.activeFilter === 'arbetsplatser'"
                  v-click-outside="handleClickOutside"
                >
                  <div v-if="activeFilter === 'arbetsplatser'">
                    <div class="c-office-filter__size-input-block">
                      <div class="c-office-filter__size-input-heading">
                        {{ this.translate.showdesiredworkplace }}
                      </div>
                      <div class="c-office-filter__size-input-wrapper">
                        <div class="c-office-filter__size-input-container">
                          <div class="c-office-filter__size-input-tag">Min</div>
                          <input
                            type="number"
                            class="c-office-filter__size-input"
                            min="0"
                            placeholder="0"
                            v-model="minNumberOfWorkplaces"
                          />
                          <span class="c-office-filter__size-input-m2-tag"
                            >st</span
                          >
                        </div>
                        <div
                          aria-hidden="true"
                          class="c-icon c-icon--xs c-office-filter-dropdown__toggle-icon"
                        >
                          <svg>
                            <use :xlink:href="`#icon-minus`"></use>
                          </svg>
                        </div>
                        <div class="c-office-filter__size-input-container">
                          <div class="c-office-filter__size-input-tag">Max</div>
                          <input
                            type="number"
                            class="c-office-filter__size-input"
                            min="0"
                            placeholder="0"
                            v-model="maxNumberOfWorkplaces"
                          />
                          <span class="c-office-filter__size-input-m2-tag"
                            >st</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </ul>
              </v-office-filter-dropdown>

              <button class="clear-choises-button" @click="resetFilter">
                {{ this.translate.resetchoices || "clear" }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="activeFilter" class="c-office-filter__choices-container">
          <ul class="c-office-filter__list">
            <div
              v-if="activeFilter === 'plats'"
              class="c-office-filter__city-wrapper"
              v-for="city in cities"
            >
              <!-- {{ city.display}} -->
              <li class="c-office-filter__city" v-if="!singleCity">
                <label @click="addRegionsMobile(city)">
                  <input
                    type="checkbox"
                    :value="city.value"
                    v-model="selectedPlacesMobile"
                  />
                  {{ city.display }}
                </label>
              </li>
              <li
                class="c-office-filter__region"
                v-for="region in regions"
                v-if="region.group === city.display"
              >
                <label>
                  <input
                    type="checkbox"
                    :value="region.value"
                    v-model="selectedPlacesMobile"
                  />
                  {{ region.display }}
                </label>
              </li>
            </div>
            <div
              v-if="activeFilter === 'lokal'"
              class="c-office-filter__place-wrapper"
              v-for="premise in premiseType"
            >
              <li class="c-office-filter__place">
                <label>
                  <input
                    type="checkbox"
                    :value="premise.value"
                    v-model="selectedTypesOfBuildingsMobile"
                  />
                  {{ premise.display }}
                </label>
              </li>
            </div>
            <div v-if="activeFilter === 'yta'">
              <div class="c-office-filter__size-input-block">
                <div class="c-office-filter__size-input-heading">
                  {{ this.translate.selectdesiredspace }}
                </div>
                <div class="c-office-filter__size-input-wrapper">
                  <div class="c-office-filter__size-input-container">
                    <div class="c-office-filter__size-input-tag">Min</div>
                    <input
                      type="number"
                      class="c-office-filter__size-input"
                      placeholder="0"
                      v-model="minSizeMobile"
                    />
                    <span class="c-office-filter__size-input-m2-tag"
                      >m<sup>2</sup></span
                    >
                  </div>
                  <div
                    aria-hidden="true"
                    class="c-icon c-icon--xs c-office-filter-dropdown__toggle-icon"
                  >
                    <svg>
                      <use :xlink:href="`#icon-minus`"></use>
                    </svg>
                  </div>
                  <div class="c-office-filter__size-input-container">
                    <div class="c-office-filter__size-input-tag">Max</div>
                    <input
                      type="number"
                      class="c-office-filter__size-input"
                      placeholder="0"
                      v-model="maxSizeMobile"
                    />
                    <span class="c-office-filter__size-input-m2-tag"
                      >m<sup>2</sup></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeFilter === 'arbetsplatser'">
              <div class="c-office-filter__size-input-block">
                <div class="c-office-filter__size-input-heading">
                  {{ this.translate.selectdesiredworkplace }}
                </div>
                <div class="c-office-filter__size-input-wrapper">
                  <div class="c-office-filter__size-input-container">
                    <div class="c-office-filter__size-input-tag">Min</div>
                    <input
                      type="number"
                      class="c-office-filter__size-input"
                      placeholder="0"
                      v-model="minNumberOfWorkplacesMobile"
                    />
                    <span class="c-office-filter__size-input-m2-tag">st</span>
                  </div>
                  <div
                    aria-hidden="true"
                    class="c-icon c-icon--xs c-office-filter-dropdown__toggle-icon"
                  >
                    <svg>
                      <use :xlink:href="`#icon-minus`"></use>
                    </svg>
                  </div>
                  <div class="c-office-filter__size-input-container">
                    <div class="c-office-filter__size-input-tag">Max</div>
                    <input
                      type="number"
                      class="c-office-filter__size-input"
                      placeholder="0"
                      v-model="maxNumberOfWorkplacesMobile"
                    />
                    <span class="c-office-filter__size-input-m2-tag">st</span>
                  </div>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <div v-if="activeFilter" class="c-office-filter__button-container">
          <button
            class="c-office-filter__button-cancel"
            @click="cancelFiltersMobile"
          >
            {{ this.translate.cancel }}
          </button>
          <button
            class="c-office-filter__button-save"
            @click="applyFiltersMobile"
          >
            {{ this.translate.use }}
          </button>
        </div>
      </div>
    </div>
    <div
      ref="resultsSection"
      class="c-office-filter__bottom-wrapper o-width-limiter--full"
    >
      <section class="c-office-filter__hits">
        <div v-if="!showMap" class="c-office-filter__sorting-container">
          <div class="">
            <div class="c-office-filter__right-item">
              <span>{{ this.translate.sorton }}:</span>
              <button
                class="c-office-filter__sorting-select"
                id="sorting-select"
                @click="showSortingOptions = !showSortingOptions"
              >
                {{ activeSorting.display }}
                <div
                  aria-hidden="true"
                  class="c-icon c-icon--xs c-office-filter-dropdown__toggle-icon"
                >
                  <svg>
                    <use :xlink:href="`#icon-select-arrow`"></use>
                  </svg>
                </div>
              </button>
              <ul
                v-if="showSortingOptions"
                v-click-outside="handleClickOutside"
                class="c-office-filter__sorting-options-dropdown"
              >
                <li
                  class="c-office-filter__sorting-option"
                  :class="{
                    'c-office-filter__sorting-option--active':
                      option === activeSorting,
                  }"
                  v-for="(option, index) in sortOptions"
                  :key="index"
                  @click="selectSortingOption(option)"
                >
                  <div
                    v-if="option === activeSorting"
                    aria-hidden="true"
                    class="c-icon c-icon--xs c-office-filter__check-icon"
                  >
                    <svg>
                      <use :xlink:href="`#icon-check`"></use>
                    </svg>
                  </div>
                  {{ option.display }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          v-if="showMap && isLgDesktop"
          class="c-office-filter__sorting"
        ></div>
        <h3 class="c-office-filter__hits-heading">
          <span class="c-office-filter__hits-number">{{ numberOfItems }}</span>
          {{ this.translate.premises }}
        </h3>
        <div class="c-office-filter__map-toggle-group">
          <button
            class="c-office-filter__toggle-button c-office-filter__toggle-button--kort"
            :class="{ 'c-office-filter__toggle-button--active': !showMap }"
            @click="showMap = false"
          >
            <i aria-hidden="true" class="fa-regular fa-grid-2"></i>
            <span v-if="isDesktop">{{ this.translate.gallery || "Kort" }}</span>
          </button>
          <button
            class="c-office-filter__toggle-button c-office-filter__toggle-button--karta"
            :class="{ 'c-office-filter__toggle-button--active': showMap }"
            @click="showMap = true"
          >
            <i aria-hidden="true" class="fa-regular fa-location-dot"></i>
            <span v-if="isDesktop">{{ this.translate.map || "Karta" }}</span>
          </button>
        </div>
      </section>
      <div v-if="showMap" id="map" class="googlemapoffice">
        <v-google-map
          v-if="showMap"
          :selectedPlaces="selectedPlaces"
          :selectedTypesOfBuildings="selectedTypesOfBuildings"
          :minSize="minSize"
          :maxSize="maxSize"
          :objects="this.objects"
          :apiKey="this.apiKey"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VOfficeFilterDropdown from "./dropdown/VOfficeFilterDropdown.vue";
import VOfficeFilterDropdownMobile from "./dropdown/VOfficeFilterDropdownMobile.vue";
import vClickOutside from "v-click-outside";
import VGoogleMap from "./VGoogleMap.vue";

export default {
  name: "VFilter",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    VOfficeFilterDropdown,
    VOfficeFilterDropdownMobile,
    VGoogleMap,
  },

  props: {
    objects: {
      type: Array,
    },
    multiSelectFilters: {
      type: Array,
      default: () => [],
    },
    objectsFetched: {
      type: Boolean,
      default: false,
    },
    apiKey: {
      type: String,
      required: true,
    },
    translationString: {
      type: [Object, String],
    },
    numberOfItems: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  data() {
    return {
      cities: [],
      regions: [],
      premiseType: [],
      showSortingOptions: false,
      sortOptions: [
        {
          display: "Adress: A - Ö",
          value: 1,
        },
        {
          display: "Adress: Ö - A",
          value: 2,
        },
        {
          display: "Senaste objekt",
          value: 3,
        },
        {
          display: "Yta: minst",
          value: 4,
        },
        {
          display: "Yta: störst",
          value: 5,
        },
      ],
      activeSorting: {},
      activeFilter: "",
      selectedPlaces: [],
      selectedTypesOfBuildings: [],
      minSize: "",
      maxSize: "",
      minNumberOfWorkplaces: "",
      maxNumberOfWorkplaces: "",
      selectedPlacesMobile: [],
      selectedTypesOfBuildingsMobile: [],
      minSizeMobile: "",
      maxSizeMobile: "",
      minNumberOfWorkplacesMobile: "",
      maxNumberOfWorkplacesMobile: "",
      selectedPlaceIds: [],
      selectedDistrictIds: [],
      selectedPremiseTypeIds: [],
      hits: [],
      showFilters: false,
      isDesktop: false,
      isFilterVisible: false,
      translate: {},
      filters: [
        {
          name: "Område",
          type: "plats",
          options: ["Utförande 1", "Utförande 2", "Utförande 3"],
          selectedOptions: [],
        },
        {
          name: "Lokal",
          type: "lokal",
          options: ["Lokal 1", "Lokal 2", "Lokal 3"],
          selectedOptions: [],
        },
        {
          name: "Yta",
          type: "yta",
          options: ["Yta 1", "Yta 2", "Yta 3"],
          selectedOptions: [],
        },
      ],
      activeDropdown: null,
      showMap: false,
      syncingFromServer: false,
    };
  },
  methods: {
    /**
     * Rebuild cities, regions, and premiseType arrays from multiSelectFilters.
     * Called when activeFilter changes or when multiSelectFilters update from server.
     */
    rebuildFilterOptions() {
      this.cities = [];
      this.regions = [];
      this.premiseType = [];

      this.multiSelectFilters.forEach((filter) => {
        if (filter.name === "location") {
          filter.items.forEach((item) => {
            if (item.groupLabel) {
              if (!this.cities.find((c) => c.value === item.value)) {
                this.cities.push(item);
              }
            } else {
              if (!this.regions.find((r) => r.value === item.value)) {
                this.regions.push(item);
              }
            }
          });
        } else if (filter.name === "premisetype") {
          filter.items.forEach((item) => {
            if (!this.premiseType.find((p) => p.value === item.value)) {
              this.premiseType.push(item);
            }
          });
        }
      });
    },

    /**
     * Sync selectedPlaces and selectedTypesOfBuildings from the server's Active flags.
     * This ensures that after a POST response, the filter checkboxes reflect the
     * server-reported active state.
     */
    syncActiveFiltersFromServer() {
      const newSelectedPlaces = [];
      const newSelectedTypes = [];
      const newSelectedPlaceIds = [];
      const newSelectedDistrictIds = [];
      const newSelectedPremiseTypeIds = [];

      this.multiSelectFilters.forEach((filter) => {
        if (filter.name === "location") {
          filter.items.forEach((item) => {
            if (item.checked) {
              newSelectedPlaces.push(item.value);
              // Track IDs separately for POST requests
              if (item.groupLabel) {
                // This is a city
                newSelectedPlaceIds.push(item.id);
              } else {
                // This is a district
                newSelectedDistrictIds.push(item.id);
              }
            }
          });
        } else if (filter.name === "premisetype") {
          filter.items.forEach((item) => {
            if (item.checked) {
              newSelectedTypes.push(item.value);
              newSelectedPremiseTypeIds.push(item.id);
            }
          });
        }
      });

      // Only update if server reported active filters, to avoid
      // clearing user selections on every response.
      // Use syncingFromServer flag to prevent triggering the
      // selectedPlaces/selectedTypesOfBuildings watchers which
      // would emit back to the parent and cause a circular loop.
      if (newSelectedPlaces.length > 0 || newSelectedTypes.length > 0) {
        this.syncingFromServer = true;
        this.selectedPlaces = newSelectedPlaces;
        this.selectedPlacesMobile = [...newSelectedPlaces];
        this.selectedTypesOfBuildings = newSelectedTypes;
        this.selectedTypesOfBuildingsMobile = [...newSelectedTypes];
        this.selectedPlaceIds = newSelectedPlaceIds;
        this.selectedDistrictIds = newSelectedDistrictIds;
        this.selectedPremiseTypeIds = newSelectedPremiseTypeIds;
        this.$nextTick(() => {
          this.syncingFromServer = false;
        });
      }
    },

    removeTag(tag) {
      if (this.selectedPlaces.includes(tag)) {
        this.selectedPlaces = this.selectedPlaces.filter((t) => t !== tag);
      }
      if (this.selectedTypesOfBuildings.includes(tag)) {
        this.selectedTypesOfBuildings = this.selectedTypesOfBuildings.filter(
          (t) => t !== tag,
        );
      }
      this.extractAndTrackFilterIds();
    },
    /**
     * Extract and track filter IDs from selectedPlaces and selectedTypesOfBuildings
     * This maps the selected filter values back to their IDs for POST requests
     */
    extractAndTrackFilterIds() {
      this.selectedPlaceIds = [];
      this.selectedDistrictIds = [];
      this.selectedPremiseTypeIds = [];

      // Track place/district IDs
      if (this.multiSelectFilters && this.multiSelectFilters.length > 0) {
        const locationFilter = this.multiSelectFilters.find(
          (f) => f.name === "location",
        );
        if (locationFilter && locationFilter.items) {
          locationFilter.items.forEach((item) => {
            if (this.selectedPlaces.includes(item.value)) {
              if (item.groupLabel) {
                // City level
                this.selectedPlaceIds.push(item.id);
              } else {
                // District level
                this.selectedDistrictIds.push(item.id);
              }
            }
          });
        }

        // Track premise type IDs
        const premiseFilter = this.multiSelectFilters.find(
          (f) => f.name === "premisetype",
        );
        if (premiseFilter && premiseFilter.items) {
          premiseFilter.items.forEach((item) => {
            if (this.selectedTypesOfBuildings.includes(item.value)) {
              this.selectedPremiseTypeIds.push(item.id);
            }
          });
        }
      }
    },
    capitalizeFirstLetter(tag) {
      return tag
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ");
    },
    handleFilterData(data) {
      let filter;

      data.forEach((element) => {
        filter = element.tag;
      });
      this.activeFilter = this.activeFilter === filter ? "" : filter;
    },
    selectSortingOption(option) {
      this.activeSorting = option;
      this.showSortingOptions = false;
      this.setSortingOption(option);
    },
    addRegions(city) {
      this.regions.forEach((region) => {
        if (
          region.group === city.value &&
          !this.selectedPlaces.includes(region.value) &&
          !this.selectedPlaces.includes(city.value)
        ) {
          this.selectedPlaces.push(region.value);
        } else if (this.selectedPlaces.includes(city.value)) {
          this.selectedPlaces.forEach((selected, index) => {
            const [place, regionCity] = selected.split("-");
            const cityToLower = city.value.toLowerCase();
            if (selected === region.value && regionCity === cityToLower) {
              this.selectedPlaces.splice(index, 1);
            }
          });
        }
      });
    },
    addRegionsMobile(city) {
      this.regions.forEach((region) => {
        if (
          region.group === city.value &&
          !this.selectedPlacesMobile.includes(region.value) &&
          !this.selectedPlacesMobile.includes(city.value)
        ) {
          this.selectedPlacesMobile.push(region.value);
        } else if (this.selectedPlacesMobile.includes(city.value)) {
          this.selectedPlacesMobile.forEach((selected, index) => {
            if (selected === region.value) {
              this.selectedPlacesMobile.splice(index, 1);
            }
          });
        }
      });
    },
    resetFilter() {
      this.activeSorting = this.sortOptions[2];
      this.selectedPlaces = [];
      this.selectedPlacesMobile = [];
      this.selectedTypesOfBuildings = [];
      this.selectedTypesOfBuildingsMobile = [];
      this.minSize = "";
      this.minSizeMobile = "";
      this.maxSize = "";
      this.maxSizeMobile = "";
      this.minNumberOfWorkplaces = "";
      this.maxNumberOfWorkplaces = "";
      this.minNumberOfWorkplacesMobile = "";
      this.maxNumberOfWorkplacesMobile = "";
      this.activeFilter = "";
      this.showFilters = false;
    },

    setMultiSelectFilter(filter) {
      this.$emit("setMultiSelectFilter", filter);
    },
    setSelectedPlacesLength(length) {
      this.$emit("setSelectedPlacesLength", length);
    },
    setSelectedTypesOfBuildingsLength(length) {
      this.$emit("setSelectedTypesOfBuildingsLength", length);
    },
    setMinSize(size) {
      this.$emit("setMinSize", size);
    },
    setMaxSize(size) {
      this.$emit("setMaxSize", size);
    },
    setMinWorkplaces(size) {
      this.$emit("setMinWorkplaces", size);
    },
    setMaxWorkplaces(size) {
      this.$emit("setMaxWorkplaces", size);
    },
    setSortingOption(option) {
      this.$emit("setSortingOption", option);
    },
    setFilterIds(placeIds, districtIds, premiseTypeIds) {
      this.$emit("setFilterIds", {
        placeIds,
        districtIds,
        premiseTypeIds,
      });
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth >= 768;
      this.isLgDesktop = window.innerWidth >= 1024;
    },
    applyFiltersMobile() {
      if (
        this.minSizeMobile !== "" &&
        this.maxSizeMobile !== "" &&
        Number(this.minSizeMobile) > Number(this.maxSizeMobile)
      ) {
        this.maxSizeMobile = this.minSizeMobile;
      }
      if (
        this.minNumberOfWorkplacesMobile !== "" &&
        this.maxNumberOfWorkplacesMobile !== "" &&
        Number(this.minNumberOfWorkplacesMobile) >
          Number(this.maxNumberOfWorkplacesMobile)
      ) {
        this.maxNumberOfWorkplacesMobile = this.minNumberOfWorkplacesMobile;
      }
      this.selectedPlaces = [...this.selectedPlacesMobile];
      this.selectedTypesOfBuildings = [...this.selectedTypesOfBuildingsMobile];
      this.minSize = this.minSizeMobile;
      this.maxSize = this.maxSizeMobile;
      this.minNumberOfWorkplaces = this.minNumberOfWorkplacesMobile;
      this.maxNumberOfWorkplaces = this.maxNumberOfWorkplacesMobile;
      this.activeFilter = "";
      this.showFilters = false;
      this.scrollToResults();
    },
    /**
     * Discard any unapplied edits made in the mobile filter panel and
     * revert the mobile draft fields back to the last applied values.
     */
    cancelFiltersMobile() {
      this.selectedPlacesMobile = [...this.selectedPlaces];
      this.selectedTypesOfBuildingsMobile = [...this.selectedTypesOfBuildings];
      this.minSizeMobile = this.minSize;
      this.maxSizeMobile = this.maxSize;
      this.minNumberOfWorkplacesMobile = this.minNumberOfWorkplaces;
      this.maxNumberOfWorkplacesMobile = this.maxNumberOfWorkplaces;
      this.activeFilter = "";
      this.showFilters = false;
      this.scrollToResults();
    },
    /**
     * Scroll the results section into view, offset 100px further up so it
     * doesn't land flush against the top of the viewport.
     */
    scrollToResults() {
      this.$nextTick(() => {
        if (this.$refs.resultsSection) {
          const targetTop =
            window.pageYOffset +
            this.$refs.resultsSection.getBoundingClientRect().top -
            100;
          window.scrollTo({
            top: targetTop,
            behavior: "smooth",
          });
        }
      });
    },
    handleClickOutside() {
      if (this.activeFilter === "plats" && this.isDesktop) {
        this.activeFilter = "";
      } else if (this.activeFilter === "lokal" && this.isDesktop) {
        this.activeFilter = "";
      } else if (this.activeFilter === "yta" && this.isDesktop) {
        this.activeFilter = "";
      } else if (this.activeFilter === "arbetsplatser" && this.isDesktop) {
        this.activeFilter = "";
      }

      if (this.showSortingOptions && this.isDesktop) {
        this.showSortingOptions = false;
      }
    },
    handleRemovePlace(value) {
      this.selectedPlaces = this.selectedPlaces.filter(
        (place) => place !== value,
      );
      this.selectedTypesOfBuildings = this.selectedTypesOfBuildings.filter(
        (place) => place !== value,
      );
      this.updateSelectedPlaces();
      this.updateSelectedTypesOfBuildings();
    },
    updateSelectedPlaces() {
      this.regions.forEach((region) => {
        if (
          !this.selectedPlaces.includes(region.value) &&
          this.selectedPlaces.includes(region.group)
        ) {
          this.selectedPlaces = this.selectedPlaces.filter(
            (place) => place !== region.group,
          );
        }
      });
      this.extractAndTrackFilterIds();
      this.setSelectedPlacesLength(this.selectedPlaces.length);
      this.setFilterIds(
        this.selectedPlaceIds,
        this.selectedDistrictIds,
        this.selectedPremiseTypeIds,
      );
      this.setMultiSelectFilter(
        this.selectedTypesOfBuildings.concat(this.selectedPlaces),
      );
    },
    updateSelectedTypesOfBuildings() {
      this.extractAndTrackFilterIds();
      this.setSelectedTypesOfBuildingsLength(
        this.selectedTypesOfBuildings.length,
      );
      this.setFilterIds(
        this.selectedPlaceIds,
        this.selectedDistrictIds,
        this.selectedPremiseTypeIds,
      );
      this.setMultiSelectFilter(
        this.selectedTypesOfBuildings.concat(this.selectedPlaces),
      );
    },
    removeTag(tagToRemove) {
      this.selectedPlaces = this.selectedPlaces.filter(
        (tag) => tag !== tagToRemove,
      );
      this.selectedTypesOfBuildings = this.selectedTypesOfBuildings.filter(
        (tag) => tag !== tagToRemove,
      );
    },
  },
  computed: {
    singleCity() {
      return this.cities.length === 1;
    },
    displayTags() {
      const tags = this.combinedTags.map((tag) => {
        const [firstPart] = tag.split("-");
        return {
          original: tag,
          displayText: firstPart.charAt(0).toUpperCase() + firstPart.slice(1),
        };
      });

      return tags.slice(0, 4);
    },
    combinedTags() {
      return [...this.selectedPlaces, ...this.selectedTypesOfBuildings];
    },
    selectedFilters() {
      return this.filters.flatMap((filter) => filter.selectedOptions);
    },
    filteredResults() {
      return Array(this.selectedFilters.length || 87).fill("Result");
    },
    hasSelectedFilters() {
      return this.selectedFilters.length > 0;
    },
    placesButtonText() {
      if (this.selectedPlaces.length === 0) {
        return this.translate.selectarea;
      } else {
        return this.selectedPlaces.length + " " + this.translate.chosen;
      }
    },
    typeOfBuildingButtonText() {
      if (this.selectedTypesOfBuildings.length === 0) {
        return this.translate.selectpremise;
      } else {
        return this.selectedTypesOfBuildings.length + " " + this.translate.chosen;
      }
    },
    buildingSizeText() {
      if (
        this.minSize === "" &&
        (this.maxSize === "" || this.maxSize === "0")
      ) {
        return this.translate.selectspace;
      } else {
        return this.minSize + " - " + this.maxSize + " m²";
      }
    },
    buildingNumberOfWorkplaces() {
      if (
        this.minNumberOfWorkplaces === "" &&
        (this.maxNumberOfWorkplaces === "" ||
          this.maxNumberOfWorkplaces === "0")
      ) {
        return this.translate.selectworkplaces;
      } else {
        return (
          this.minNumberOfWorkplaces +
          " - " +
          this.maxNumberOfWorkplaces +
          " st"
        );
      }
    },
  },
  watch: {
    selectedPlaces() {
      if (this.syncingFromServer) return;
      this.regions.forEach((region) => {
        if (
          !this.selectedPlaces.includes(region.value) &&
          this.selectedPlaces.includes(region.group)
        ) {
          this.selectedPlaces = this.selectedPlaces.filter(
            (place) => place !== region.group,
          );
        }
      });
      this.extractAndTrackFilterIds();
      this.setSelectedPlacesLength(this.selectedPlaces.length);
      this.setFilterIds(
        this.selectedPlaceIds,
        this.selectedDistrictIds,
        this.selectedPremiseTypeIds,
      );
      this.setMultiSelectFilter(
        this.selectedTypesOfBuildings.concat(this.selectedPlaces),
      );
    },
    selectedTypesOfBuildings() {
      if (this.syncingFromServer) return;
      this.extractAndTrackFilterIds();
      this.setSelectedTypesOfBuildingsLength(
        this.selectedTypesOfBuildings.length,
      );
      this.setFilterIds(
        this.selectedPlaceIds,
        this.selectedDistrictIds,
        this.selectedPremiseTypeIds,
      );
      this.setMultiSelectFilter(
        this.selectedTypesOfBuildings.concat(this.selectedPlaces),
      );
    },
    minSize() {
      if (this.syncingFromServer) return;
      clearTimeout(this._sizeClampTimer);
      this._sizeClampTimer = setTimeout(() => {
        if (
          this.minSize !== "" &&
          this.maxSize !== "" &&
          Number(this.minSize) > Number(this.maxSize)
        ) {
          this.maxSize = this.minSize;
        }
      }, 800);
      this.setMinSize(this.minSize);
      this.setMultiSelectFilter(
        this.selectedTypesOfBuildings.concat(this.selectedPlaces),
      );
    },
    maxSize() {
      if (this.syncingFromServer) return;
      clearTimeout(this._sizeClampTimer);
      this._sizeClampTimer = setTimeout(() => {
        if (
          this.minSize !== "" &&
          this.maxSize !== "" &&
          Number(this.maxSize) < Number(this.minSize)
        ) {
          this.minSize = this.maxSize;
        }
      }, 800);
      this.setMaxSize(this.maxSize);
      this.setMultiSelectFilter(
        this.selectedTypesOfBuildings.concat(this.selectedPlaces),
      );
    },
    minNumberOfWorkplaces() {
      if (this.syncingFromServer) return;
      clearTimeout(this._workplacesClampTimer);
      this._workplacesClampTimer = setTimeout(() => {
        if (
          this.minNumberOfWorkplaces !== "" &&
          this.maxNumberOfWorkplaces !== "" &&
          Number(this.minNumberOfWorkplaces) >
            Number(this.maxNumberOfWorkplaces)
        ) {
          this.maxNumberOfWorkplaces = this.minNumberOfWorkplaces;
        }
      }, 800);
      this.setMinWorkplaces(this.minNumberOfWorkplaces);
    },
    maxNumberOfWorkplaces() {
      if (this.syncingFromServer) return;
      clearTimeout(this._workplacesClampTimer);
      this._workplacesClampTimer = setTimeout(() => {
        if (
          this.minNumberOfWorkplaces !== "" &&
          this.maxNumberOfWorkplaces !== "" &&
          Number(this.maxNumberOfWorkplaces) <
            Number(this.minNumberOfWorkplaces)
        ) {
          this.minNumberOfWorkplaces = this.maxNumberOfWorkplaces;
        }
      }, 800);
      this.setMaxWorkplaces(this.maxNumberOfWorkplaces);
    },
    activeSorting() {
      this.setSortingOption(this.activeSorting);
    },
    activeFilter() {
      this.rebuildFilterOptions();
    },
    multiSelectFilters: {
      handler() {
        this.rebuildFilterOptions();
        this.syncActiveFiltersFromServer();
      },
      deep: true,
    },
    showFilters() {
      document.querySelector("body").style.overflow = this.showFilters
        ? "hidden"
        : "auto";
    },
    objectsFetched() {
      return;
    },
  },
  created() {
    // Handle both string and object types for translationString
    if (typeof this.translationString === "string") {
      this.translate = JSON.parse(this.translationString);
    } else if (
      typeof this.translationString === "object" &&
      this.translationString !== null
    ) {
      this.translate = this.translationString;
    } else {
      console.warn("translationString prop is not a valid string or object");
      this.translate = {};
    }

    this.sortOptions = [
      {
        display: this.translate.adressasc,
        value: 1,
      },
      {
        display: this.translate.adressdesc,
        value: 2,
      },
      {
        display: this.translate.latestobject,
        value: 3,
      },
      {
        display: this.translate.spacemin,
        value: 4,
      },
      {
        display: this.translate.spacemax,
        value: 5,
      },
    ];

    this.activeSorting = this.sortOptions[2];
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
};
</script>
